import utils from '@/_modules/utils';

class _bgShadow {
  constructor() {}

  once() {
    this.el = document.getElementById('c-bgShadow');
    this.blocks = document.querySelectorAll('.bg-shadow-js');
    this.blockHeight = 0;

    if (this.blocks.length > 0) {
      this.el.style.visibility = 'visible';
      this.resize();
    }
  }

  resize() {
    this.blockHeight = window.innerHeight * 0.75;
    this.blocks.forEach(this.setHeight.bind(this));
    this.el.style.height = this.blockHeight + 'px';
  }

  setHeight(el, i) {
    this.blockHeight += el.getBoundingClientRect().height;
  }
}

const bgShadow = new _bgShadow();

export default bgShadow;